import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-black" data-id="element-180" data-mp="ej4pg2ybuli3">
      {/* Background Effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-181" data-mp="9igx9dyd3yma"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-182" data-mp="1297ba1bnev89"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-183" data-mp="xbfi73z9p32h">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-184" data-mp="sarvgui2n8e2">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6
        }} className="w-full max-w-2xl mx-auto" data-id="element-185" data-mp="nc87kojx3mj2">
            <img src="https://cdn.magicpatterns.com/uploads/k6XyfUe3KTE98mWwchGFsC/Mikes_Pro_Web_2.png" alt="Mike's Pro Web Design logo" className="w-full h-auto" data-id="element-186" data-mp="381e1rd3l65u1" />
          </motion.div>

          <motion.a href="tel:818-381-9905" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} className="font-bold text-white text-[clamp(1rem,5vw,3.75rem)] whitespace-nowrap leading-tight text-center -mt-2 md:-mt-10 mb-10 hover:text-blue-400 transition-colors" data-id="element-187" data-mp="3o7vllomspvze">
            Call or Text (818) 381-9905
          </motion.a>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-8" data-id="element-188" data-mp="2qjv80ssep7bv">
            <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-189" data-mp="2ljpbay7a4umx"></span>
            Available for new projects
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-heading font-bold text-white leading-tight mb-6" data-id="element-190" data-mp="s44i1nkpdlhw">
            Custom Websites That Help Your Business{' '}
            <span className="text-gradient" data-id="element-191" data-mp="1azumrik0svzh">Stand Out and Grow</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed text-[#FFFFFF]" data-id="element-192" data-mp="161jc55lwihg7">
            Professional website design, development built directly by the owner
            without agency overhead or unnecessary costs.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-193" data-mp="3htpy5s2pykmg">
            <a href="#contact" className="w-full sm:w-auto px-8 py-4 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium text-lg hover:shadow-[0_0_30px_rgba(59,130,246,0.4)] transition-all flex items-center justify-center gap-2 group" data-id="element-194" data-mp="267whkebivk4w">
              Get a Free Quote
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-195" data-mp="2kx2hk4i6pedu" />
            </a>
            <a href="#portfolio" className="w-full sm:w-auto px-8 py-4 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium text-lg transition-all" data-id="element-196" data-mp="2oyebunc06nsd">
              View My Work
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-16 flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-197" data-mp="zkrbass95wd4">
            <div className="flex items-center gap-2" data-id="element-198" data-mp="3vk1hdtkm3sv4">
              <CheckCircle2 size={16} className="text-blue-500" data-id="element-199" data-mp="e88wi227gg4h" />
              <span className="text-[#FFFFFF]" data-id="element-200" data-mp="99xlho06bzko">Direct Owner Communication</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-201" data-mp="3hq0qtn3tdc5u">
              <CheckCircle2 size={16} className="text-blue-500" data-id="element-202" data-mp="3hqjz0c3nwm6o" />
              <span className="text-[#FFFFFF]" data-id="element-203" data-mp="3cs8r46wxglr3">Fast Turnaround</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-204" data-mp="3rglmb1o6y0kj">
              <CheckCircle2 size={16} className="text-blue-500" data-id="element-205" data-mp="3ri6lx5pd49p9" />
              <span className="text-[#FFFFFF]" data-id="element-206" data-mp="3moligy502nio">No Outsourcing</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}